// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"ae5b7047","484":"d1779b07","551":"82a888db","828":"4ad5aabd"}[chunkId] + ".chunk.js";
};